/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import CardDetails from "./CardDetails";

export  {
  CardDetails
};
